// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { browserLocalPersistence, getAuth, setPersistence } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getPerformance } from "firebase/performance";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBwO0meIHorpwjf1GfZaH-Fv2htlchvmZw",
  authDomain: "lease-management-system-33fba.firebaseapp.com",
  projectId: "lease-management-system-33fba",
  storageBucket: "lease-management-system-33fba.appspot.com",
  messagingSenderId: "271598570096",
  appId: "1:271598570096:web:366b7a096ba3191c6d42b5",
  measurementId: "G-QWZPL3J3WC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth=getAuth(app)
const db = getFirestore(app); 
const perf = getPerformance(app);
setPersistence(auth, browserLocalPersistence);
export { auth,db };